import { PropType, defineComponent } from 'vue';
import config from '@/config/app';
import  "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
export default defineComponent({
  name: 'tyreTab',
  data() {
    return {
      tyreList:config.sswWheelBrands[this.wheel],
    }
  },
  props: {
    wheel: { type: String as PropType<"ssw" | "diesel" | "flotec">, default: "ssw", required: true }
  },
  methods: {
    openInfo(id: any){
      var element :any = document.getElementById('myTabContent');
      var team = element.offsetTop;
      window.scrollTo(0, team);
    },
    getImgUrl(pic : any) {
      var images = require.context('@/assets/images/ssw/tyre-range/')
      return images('./' + pic)
    }
  },
});